import { computed } from "vue";

/**
 * Lipscore API key from the layout (or legacy top bar); `null` when off.
 * An unset `lipscore_enable` counts as on.
 */
export const useLipscoreApiKey = () => {
	const appStore = useAppStore();

	return computed<string | null>(() => {
		if (appStore.lipscore_api_key) {
			const enabled =
				appStore.lipscore_enable === null ||
				appStore.lipscore_enable === true ||
				String(appStore.lipscore_enable) === "true";
			return enabled ? appStore.lipscore_api_key : null;
		}
		// Legacy field, not on the TopBar type.
		return (appStore.topBar as any)?.lipscore_api_key || null;
	});
};
